import { GreenCheck, RedStop, YellowCheck, RedCheck } from "../../Decorators/Checkmarks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBatteryEmpty, faBatteryQuarter, faBinoculars, faTemperatureLow, 
  faTemperatureHigh, faExclamationTriangle} 
       from "@fortawesome/free-solid-svg-icons";

export async function getIcons (props) {
  const url = "/tehama/sites/"+props?.ac+'/icons'
  const pr = props.ss.apiData(url)
  return pr.then((resp) => {
    if (resp?.data?.data)
      return resp.data
    if (resp?.data) {
      try {
        const t = resp.data.replace(/[\n\r]/g, '')
        const json = JSON.parse(t)
        //console.log (json )
        return json
      }
      catch (e) {
        // console.log (e)
        return e
      }
    }  
  })
}

export function deviceIcon (apiIcons, deviceId) {
  return apiIcons.find(i=>i.device_id?.toUpperCase() === deviceId?.toUpperCase())
}

const iconTable = [
  {name: 'GRN_CHK', html: <GreenCheck />},
  {name: 'LOW_TEMP', html: <div className='fa-dot' key="cold1"><FontAwesomeIcon icon={faTemperatureLow} color="blue" size="lg" /></div>},
  {name: 'HIGH_TEMP', html: <div className='fa-dot' key="hot1"><FontAwesomeIcon icon={faTemperatureHigh} color="red" size="lg" /></div>},
  {name: 'NO_MONITOR_DATA', html:<div className='fa-dot' key='lost1'><FontAwesomeIcon icon={faBinoculars} color="#404040" size="lg" /></div>},
  {name: 'BATT_BLK', html: <div className='fa-dot' key='ded1'><FontAwesomeIcon icon={faBatteryEmpty} color="gray" size="lg" /></div>},
  {name: 'BATT_GRN', html:<div className='fa-dot' key='tired1'><FontAwesomeIcon icon={faBatteryQuarter} color="#0FC0A4" size="lg" /></div>},
  {name: 'UNSTABLE_NODE', html: <div className='horizontal-shake' key='un1'><GreenCheck /></div>},
  {name: 'IS_STOPPED', html: <RedStop />},
  {name: 'YELLOW_CHK', html:<YellowCheck />},
  {name: 'RED_CHK', html: <RedCheck />},
  {name: undefined, html:<div className='fa-dot' key='uncomm'>
     <FontAwesomeIcon icon={faExclamationTriangle} color="orange" size="lg" /></div>},
]

export function nameToIcon (status) {
  return iconTable.find(i=>i.name === status)?.html ?? <div>&nbsp;</div>
}